import { Box } from "@mui/material";
import "./_style.scss";
import { useContext, useEffect, useState } from "react";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkTable from "../../components/atoms/TkTable";
import { headTitleList } from "./parts";
import TkButton from "../../components/atoms/TkButton";
import TkBackButton from "../../components/molecules/TkBackButton";
import { useNavigate, useLocation } from "react-router-dom";
// import { BusinessContext } from "../../context/businessContext";// TODO 課題276持ち回り情報待ち
import { GlobalContext } from "../../context/globalContext";
import { httpAPI_APP103 } from "./api/request";
import { IRequiredProcessingProps } from "../../type/contextType/businessContext/IRequiredProcessing";

/**
 * SCRW110002 要処理一覧　担当者変更確認
 * @return SCRW110002 要処理一覧　担当者変更確認
 */
const SCRW110002 = () => {
  const navigate = useNavigate();
  const location: IRequiredProcessingProps = useLocation().state;
  const { state, setState } = useContext(GlobalContext);
  const [bodyList, setBodyList] = useState<any>([]);

  const handleChange = async () => {
    // 要処理一覧　担当者更新API 呼び出し
    try {
      let managerChangeList = location.managerList?.map((item) => {
        return {
          applyId: item.applyId,
          userId: item.newManagerUserId,
        };
      });
      const res = await httpAPI_APP103({ managerChangeList });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    let bodyList = location.managerList?.map((item) => [
      {
        children: item.applyId,
      },
      {
        children: item.bussinessType,
      },
      {
        children: item.prefecture,
      },
      {
        children: item.contractor,
      },
      {
        children: item.applyTime,
      },
      {
        children: item.status,
      },
      {
        children: item.managerName,
      },
      {
        children: item.newManagerName,
      },
    ]);

    setBodyList(bodyList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className="SCRW110002" data-testid="SCRW110002PageForTest">
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLW110002_01}</TkInfoManual>

      <TkTable headList={headTitleList} bodyList={bodyList}></TkTable>

      <Box className="btn">
        <TkBackButton />
        <TkButton onClick={handleChange}>変更</TkButton>
      </Box>
    </Box>
  );
};

export default SCRW110002;
